import React from "react";
import { motion } from "framer-motion";
import { Target, Eye, Heart } from "lucide-react";

const PILLARS = [
  {
    icon: Target,
    title: "Mission",
    body:
      "To deliver high-quality, affordable pharmaceutical solutions that improve lives — grounded in innovation, ethics, and scientific excellence.",
  },
  {
    icon: Eye,
    title: "Vision",
    body:
      "To be the most trusted pharmaceutical brand in India — recognised for research-driven products, integrity, and unwavering patient focus.",
  },
  {
    icon: Heart,
    title: "Core Values",
    body:
      "Quality first. Ethical partnerships. Continuous innovation. Compassion for patients. Sustainable growth across every operation.",
  },
];

export default function About() {
  return (
    <section id="about" className="py-24 sm:py-32 px-6 sm:px-10 lg:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <div className="section-eyebrow" data-testid="about-eyebrow">About Us</div>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-semibold tracking-tight text-slate-900" data-testid="about-heading">
            About <span className="text-gradient">Andrich Pharmaceuticals</span>
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed" data-testid="about-body">
            Andrich Pharmaceuticals Pvt. Ltd. is dedicated to delivering high-quality pharmaceutical
            solutions that improve lives. We focus on innovation, quality manufacturing, ethical
            business practices, and strong relationships with healthcare professionals across India.
            Our growing product portfolio serves multiple therapeutic segments while maintaining the
            highest standards of safety and effectiveness.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {PILLARS.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="group relative bg-white rounded-2xl border border-slate-200 p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
              data-testid={`about-pillar-${p.title.toLowerCase()}`}
            >
              <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-blue-900 to-green-600 text-white flex items-center justify-center shadow-lg shadow-blue-900/20">
                <p.icon size={20} />
              </div>
              <h3 className="mt-6 font-display text-2xl font-semibold text-slate-900">{p.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{p.body}</p>
              <div className="absolute inset-x-8 bottom-0 h-px bg-gradient-to-r from-transparent via-blue-200 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
